{
  "version": 1,
  "asset_id": "cce9573c-d962-4852-8a87-c43074c3651b",
  "project_id": "9fb22223-732b-4b0d-9eac-b115ce8cfd9c",
  "url": "/__l5e/assets-v1/cce9573c-d962-4852-8a87-c43074c3651b/meta.svg",
  "r2_key": "a/v1/9fb22223-732b-4b0d-9eac-b115ce8cfd9c/cce9573c-d962-4852-8a87-c43074c3651b/meta.svg",
  "original_filename": "meta.svg",
  "size": 3383,
  "content_type": "image/svg+xml",
  "created_at": "2026-06-16T14:53:48Z"
}
